<go-loader *ngIf="loading"></go-loader>

<span  *ngIf="!loading">
  Id: {{ row.id }}
</span>
